import React, { useState, useEffect } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import logo from "../img/eaim_logo_original.png";
import { Image } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import socket from "./socket";

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [quote, setQuote] = useState("");
  const [author, setAuthor] = useState("");
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [errorMsg, setErrorMsg] = useState("");

  useEffect(() => {
    const fetchQuote = async () => {
      try {
        const res = await axios.get(
          "https://api.allorigins.win/get?url=" +
            encodeURIComponent("https://zenquotes.io/api/quotes")
        );

        const quotes = JSON.parse(res.data.contents);
        const randomIndex = Math.floor(Math.random() * quotes.length);
        const randomQuote = quotes[randomIndex];
        setQuote(randomQuote.q);
        setAuthor(randomQuote.a);
      } catch (err) {
        setQuote(
          "Success is no accident. It is hard work, perseverance, learning, studying, sacrifice and most of all, love of what you are doing or learning to do."
        );
        setAuthor("Pelé");
      }
    };

    fetchQuote();
  }, []);

  useEffect(() => {
    if (errorMsg) {
      const timer = setTimeout(() => {
        setErrorMsg("");
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [errorMsg]);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(`${process.env.REACT_APP_API}/login`, {
        userName,
        password,
      });

      if (response.data.success) {
        const user = response.data.user;
        const token = response.data.token;

        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("authToken", token);

        socket.connect();
        socket.emit("register", user.user_name);

        navigate("/home");
      } else {
        setErrorMsg(response.data.message || "Login failed.");
      }
    } catch (error) {
      if (error.response && error.response.data.message) {
        setErrorMsg(error.response.data.message);
      } else {
        setErrorMsg("Server error. Please try again later.");
      }
    }
  };
  
  return (
    <div
      style={{
        height: "100vh",
        width: "100vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "#000",
        position: "relative",
        overflow: "hidden",
        flexDirection: "column",
      }}
    >
      <img
        src="https://media3.giphy.com/media/v1.Y2lkPTc5MGI3NjExZ3U1YmFmdHZkNm1rYnUzZDg0amNyenV2OTFwbmJhdHNhbWh4em9oZyZlcD12MV9pbnRlcm5hbF9naWZfYnlfaWQmY3Q9Zw/YOAqV6wRGOEVM48svy/giphy.gif"
        alt="Background Animation"
        style={{
          position: "absolute",
          width: "70%",
          maxWidth: "1000px",
          zIndex: 0,
          opacity: 0.5,
        }}
      />

      <div
        style={{
          position: "absolute",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: 1,
        }}
      />

      <div style={{ zIndex: 2 }}>
        <Image src={logo} width="300px" alt="Logo" />
      </div>

      {errorMsg && (
        <div className="alert alert-warning" style={{ zIndex: 2 }}>
          ⚠️ {errorMsg}
        </div>
      )}

      <div
        style={{
          position: "relative",
          backgroundColor: "rgba(0, 0, 0, 0.3)",
          backdropFilter: "blur(8px)",
          WebkitBackdropFilter: "blur(8px)",
          borderRadius: "10px",
          border: "1px solid rgba(255, 255, 255, 0.1)",
          padding: "20px 30px",
          boxShadow: "0 0 20px rgba(0,0,0,0.5)",
          zIndex: 2,
          width: "100%",
          maxWidth: "400px",
          color: "#fff",
          marginBottom: "100px",
        }}
      >
        <h4 style={{ textAlign: "center", marginBottom: "30px" }}>Log in</h4>

        <form onSubmit={handleLogin}>
          <div style={{ marginBottom: "20px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Username
            </label>
            <input
              type="text"
              placeholder="Enter your username"
              style={{
                width: "100%",
                padding: "10px",
                borderRadius: "6px",
                border: "1px solid #555",
                backgroundColor: "#2c2c2c",
                color: "#fff",
              }}
              required
              value={userName}
              onChange={(e) => setUserName(e.target.value)}
            />
          </div>

          <div style={{ marginBottom: "25px" }}>
            <label style={{ display: "block", marginBottom: "6px" }}>
              Password
            </label>
            <div style={{ position: "relative" }}>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                style={{
                  width: "100%",
                  padding: "10px",
                  paddingRight: "35px",
                  borderRadius: "6px",
                  border: "1px solid #555",
                  backgroundColor: "#2c2c2c",
                  color: "#fff",
                }}
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <span
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  position: "absolute",
                  top: "50%",
                  right: "10px",
                  transform: "translateY(-50%)",
                  color: "#ccc",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>
          </div>

          <button
            type="submit"
            style={{
              width: "100%",
              padding: "12px",
              backgroundColor: "#d11fb0",
              border: "none",
              color: "#fff",
              borderRadius: "6px",
              fontWeight: "bold",
              cursor: "pointer",
              marginBottom: "10px",
            }}
          >
            LOG IN
          </button>
        </form>

        <p style={{ textAlign: "center", color: "#ccc", fontSize: "0.7rem" }}>
          Note: Please use your SEMS account. Only authorized users can access
          this page.
        </p>
      </div>
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          width: "100%",
          textAlign: "center",
          color: "#ccc",
          fontSize: "0.8rem",
          zIndex: 2,
          padding: "0 20px",
        }}
      >
        <p style={{ marginBottom: 4, fontSize: "1rem" }}>"{quote}"</p>
        <p style={{ fontStyle: "italic", fontSize: "0.9rem", color: "#aaa" }}>
          — {author}
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
